<template>
  <div class="about">
    <header-view curr="2"></header-view>
    <div class="bodyer">
      <div class="bodyer_box">
        <div class="bodyer_left left">
          <div class="titleview">
            <titleview title="捐助排行" class="left"></titleview>
            <div class="btnbox right hand">
              <div
                class="item"
                :style="curr == 2 ? 'background: #ffffff;' : ''"
                @click="yearFun"
              >
                近一年
              </div>
              <div
                class="item"
                :style="curr == 1 ? 'background: #ffffff;' : ''"
                @click="monthFun"
              >
                近一月
              </div>
			  
			  <div
			    class="item"
			    :style="curr == 0 ? 'background: #ffffff;' : ''"
			    @click="weekFun"
			  >
			    近一周
			  </div>
            </div>
          </div>
          <div class="chartbox">
            <div class="titlebox">
              <div class="title left">捐助排行TOP 10</div>
            </div>
            <div id="myChart"></div>
          </div>
        </div>
        <bodyer-right class="right"></bodyer-right>
      </div>
      <div class="table">
        <table>
          <th style="text-align: center;">排序</th>
          <th style="text-align: center;">项目名称</th>
          <th style="text-align: center;">累积捐助金额</th>
          <th style="text-align: center;">项目需捐助金额</th>
          <th style="text-align: center;">捐助开始时间</th>
          <th style="text-align: center;">捐助结束时间</th>
          <th style="text-align: center;">备注</th>	       
          <tr v-if="list.length > 0" v-for="(item, index) in list" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <label v-if="item.thpDonationActivity != undefined">{{ item.thpDonationActivity.title }}</label>
            </td>
            <td>{{ item.total }}</td>
            <td>
              <label v-if="item.thpDonationActivity != undefined">{{ item.thpDonationActivity.targetMoney }}</label>
            </td>
            <td>
              <label v-if="item.thpDonationActivity != undefined">{{ item.thpDonationActivity.startDate }}</label>
            </td>
            <td>
              <label v-if="item.thpDonationActivity != undefined">{{ item.thpDonationActivity.endDate }}</label>
            </td>
            <td>
              <label v-if="item.thpDonationActivity != undefined">{{ item.thpDonationActivity.tip }}</label>
            </td>
            <!-- <td>{{ item.thpDonationActivity.endDate }}</td>
            <td>{{ item.thpDonationActivity.introduction }}</td> -->
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import bodyerRight from "../components/bodyer-right.vue";
export default {
  components: {
    bodyerRight
  },
  data: function() {
    return {
      startTime: "",
      endTime: "",
      myChart: "",
      list: [],
      curr: 4,
    };
  },
  mounted() {
    this.myChart = this.$echarts.init(document.getElementById("myChart"));
    this.curr = 2;
    this.startTime = this.getFirstDayOfYear(new Date());
    this.init();
  },

  created() {
    this.Cumulative();
  },
  methods: {
    init(cycle) {
      var that = this;
      this.httpGet("web/statisticsController/getWebDonationHistogram", {
        startTime: cycle == "created" ? this.day(10) : this.startTime,
        endTime: this.new_date
      }).then(res => {
        console.log(res.result);
        // if (res.result.length > 0) {
          var xAxis = [];
          var series = [];

          for (var i in res.result) {
            // xAxis[i] =
            //   res.result[i].date.split("-")[1] +
            //   "/" +
            //   res.result[i].date.split("-")[2];
			xAxis[i] = res.result[i].title;
            series[i] = res.result[i].value;
          }
		  
          // that.myChart.xAxis.data = xAxis;
          // that.myChart.series.data = series;
          // 绘制图表
          that.myChart.setOption({
            tooltip: {},
            xAxis: {
              lineStyle: {
                type: "dashed"
              },
              data: xAxis,
              itemCount: 1, //x轴单屏显示数据的数量，默认为5个
              scrollShow: true, //新增是否显示滚动条，默认false
              scrollAlign: "left", //滚动条初始位置
              gridType: "dashed",
              boundaryGap: ["5%", "5%"],
			  nameLocation:'end',//坐标轴名称显示位置。
			  // axisLabel : {//坐标轴刻度标签的相关设置。
				 //  interval:0,
				 //  rotate:"0"
			  // }
			    axisLabel : {//坐标轴刻度标签的相关设置。
				   interval:0,
				   rotate:30,
				  formatter : function(params){
					 var newParamsName = "";// 最终拼接成的字符串
						  var paramsNameNumber = params.length;// 实际标签的个数
						  var provideNumber = 8;// 每行能显示的字的个数
						  var rowNumber = Math.ceil(paramsNameNumber / provideNumber);// 换行的话，需要显示几行，向上取整
						  /**
						   * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
						   */
						  // 条件等同于rowNumber>1
						  if (paramsNameNumber > provideNumber) {
							  /** 循环每一行,p表示行 */
							  for (var p = 0; p < rowNumber; p++) {
								  var tempStr = "";// 表示每一次截取的字符串
								  var start = p * provideNumber;// 开始截取的位置
								  var end = start + provideNumber;// 结束截取的位置
								  // 此处特殊处理最后一行的索引值
								  if (p == rowNumber - 1) {
									  // 最后一次不换行
									  tempStr = params.substring(start, paramsNameNumber);
								  } else {
									  // 每一次拼接字符串并换行
									  tempStr = params.substring(start, end) + "\n";
								  }
								  newParamsName += tempStr;// 最终拼成的字符串
							  }

						  } else {
							  // 将旧标签的值赋给新标签
							  newParamsName = params;
						  }
						  //将最终的字符串返回
						  return newParamsName
				  }
			  }
			  
            },
            yAxis: {
              lineStyle: {
                type: "dashed"
              },
              splitLine: {
                show: true,
                lineStyle: {
                  type: "dashed"
                }
              }
            },
            series: [
              {
                type: "bar",
                data: series,
                barWidth: "12"
              }
            ],
            legend: {
              type: "scroll",
              orient: "horizontal",
              y: "top",
              right: 200,
              left: 100,
              top: 1,
              bottom: 1
            }
          });
		  
        // }
     
	  });
	 
    },
    Cumulative() {
      var that = this;
      this.httpGet("web/donation/thpDonationRecord/getTotalByActivty", {
        pageNo: 1,
        pageSize: 10
      }).then(res => {
        console.log(res.result.records);
        that.list = res.result.records;
		
		console.log("长度:"+res.result.records.length);
      });
	  
	  window.pageYOffset = 0;
	  document.documentElement.scrollTop = 0;
	  document.body.scrollTop = 0;
    },
    // 最近一年
    yearFun() {
      this.curr = 2;
      this.startTime = this.getFirstDayOfYear(new Date());
      this.init();
    },
    // 最近一周
    weekFun() {
      this.curr = 0;
      this.startTime = this.getFirstDayOfWeek(new Date());
      this.init();
    },
    // 最近一月
    monthFun() {
      this.curr = 1;
	  console.log("this.curr:"+this.curr);
      this.startTime = this.getUpDayOfMonth(new Date(), 0);
      this.init();
    },
    // nun天前
    day(num) {
      // var date_getPointDate = function (currDate, num) {  //num表示天数，接受正负数
      var currDate = this.new_date;
      if (!num) {
        //做num简单验证
        return currDate;
      }
      num = Math.floor(num);
      var symbol = "/";
      if (currDate.indexOf("-") > -1) {
        symbol = "-";
        currDate = currDate.replace(/-/g, "/");
      } else if (currDate.indexOf(".") > -1) {
        symbol = ".";
        currDate = currDate.replace(/\./g, "/");
      }
      //symbol = '-'; //定制输出分隔符
      var myDate = new Date(currDate),
        lw = new Date(Number(myDate) + 1000 * 60 * 60 * 24 * num), //num天数
        lastY = lw.getFullYear(),
        lastM = lw.getMonth() + 1,
        lastD = lw.getDate(),
        startdate =
          lastY +
          symbol +
          (lastM < 10 ? "0" + lastM : lastM) +
          symbol +
          (lastD < 10 ? "0" + lastD : lastD);
      return startdate;
      // }
    },

    timeFormat(date) {
      if (!date || typeof date === "string") {
        this.error("参数异常，请检查...");
      }
      var y = date.getFullYear(); //年
      var m =
        date.getMonth() < 9
          ? "0" + Number(date.getMonth() + 1)
          : date.getMonth() + 1; //月
      var d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate(); //日
      console.log(date.getMonth());
      return y + "-" + m + "-" + d;
    },

    //获取这周的周日
    getFirstDayOfWeek(date) {
      var weekday = date.getDay() || 7; //获取星期几,getDay()返回值是 0（周日） 到 6（周六） 之间的一个整数。0||7为7，即weekday的值为1-7

      date.setDate(date.getDate() - weekday); //往前算（weekday-1）天，年份、月份会自动变化
      return this.timeFormat(date);
    },
    //获取上num周的周日
    getleftDayOfWeek(date, num) {
      var weekday = date.getDay() || 7; //获取星期几,getDay()返回值是 0（周日） 到 6（周六） 之间的一个整数。0||7为7，即weekday的值为1-7

      date.setDate(date.getDate() - weekday - 7 * num); //往前算（weekday-1）天，年份、月份会自动变化
      return this.timeFormat(date);
    },
    //获取上num周的周六
    getRightDayOfWeek(date, num) {
      var weekday = date.getDay() || 7; //获取星期几,getDay()返回值是 0（周日） 到 6（周六） 之间的一个整数。0||7为7，即weekday的值为1-7

      date.setDate(date.getDate() - weekday - 7 * num + 7); //往前算（weekday-1）天，年份、月份会自动变化
      return this.timeFormat(date);
    },
    //获取num月第一天
    getUpDayOfMonth(date, num) {
      var month = date.getMonth() - num;
      date.setMonth(month);
      date.setDate(1);
      return this.timeFormat(date);
	  // var month = date.getMonth() + 1;
	  // if(month <= 9){
		 //  month = "0" + month;
	  // }
	  // var year = date.getFullYear()
	  // return year + "-" + month + "-01" 
    },
    //获取num月最后一天
    getRightDayOMonth(date, num) {
      var month = date.getMonth() - num;
      ++month;
      date.setMonth(month);
      date.setDate(0);
      console.log(this.timeFormat(date));
      return this.timeFormat(date);
    },
    //获取num季第一天
    getFirstDayOfSeason(date, num) {
      var month = date.getMonth() - num * 3;
      if (month <= 3) {
        date.setMonth(0);
      } else if (month <= 6) {
        date.setMonth(3);
      } else if (month <= 9) {
        date.setMonth(6);
      } else {
        date.setMonth(9);
      }
      date.setDate(1);
      return this.timeFormat(date);
    },
    // 获取num季最后一天
    getRightDayOSeason(date, num) {
      var month = date.getMonth() - num * 3;
      if (month <= 3) {
        date.setMonth(3);
      } else if (month <= 6) {
        date.setMonth(6);
      } else if (month <= 9) {
        date.setMonth(9);
      } else {
        date.setMonth(12);
      }
      date.setDate(0);
      return this.timeFormat(date);
    },
    //获取当年第一天
    getFirstDayOfYear(date) {
      date.setDate(1);
      date.setMonth(0);
      return this.timeFormat(date);
    }
  }
};
</script>

<style scoped lang="scss">
th,
td,
tr,
table {
  margin: auto;
  padding: 0;
}

.about {
  // background: #f4f5f9;
  width: 100%;
  // height: 100vh;
  min-height: 10rem;
  overflow: hidden;
  position: relative;
  
}
.bodyer {
  width: 15.72rem;
  // height: 100%;
  min-height: 10rem;
  // background: #ffffff;
  margin: 2.22rem auto 0;
  // position: absolute;
  overflow: hidden;
  padding-top: 0.2rem;
  
}
.titleview {
  height: 0.38rem;
  background: #e41e15;
  // margin: 0.4rem auto 0.3rem 0.23rem;

  width: 100%;
}
.hr {
  width: 100%;
  height: 0.02rem;
  background: #ebf0f5;
}
.bodyer_box {
  overflow: hidden;
  .bodyer_left {
    width: 11.52rem;
    height: 4.06rem;
    padding: 0;

    margin: 0;
    overflow: hidden;
    .chartbox {
      width: 1152px;
      // height: 4.06rem;
      background: #ffffff;
      overflow: hidden;
      .titlebox {
        overflow: hidden;
        margin-top: 0.19rem;
        .title {
          font-size: 0.12rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #e41e15;
          margin-left: 0.2rem;
        }
      }
      #myChart {
        width: 100%;
        height: 3.23rem;
      }
    }
  }
}
.oftbox {
  border: 0.06rem solid #fafafa;
  box-shadow: 0.06rem #999999;
}
.table {
  margin: 0.14rem auto;
  width: 15.72rem;
  overflow: hidden;

  border: 1px solid #fafafa;
  box-shadow: 0px 0px 6px 0px rgba(174, 174, 174, 0.14);
}
table {
  width: 100%;
  line-height: 0.54rem;
  border-collapse: collapse;
  font-size: 0.16rem;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #1b1b1b;
  th {
    background: #f8f8f8;
  }
  tr {
	color: #666666;
    background: #ffffff;
    border-bottom: 1px solid #bbbbbb;
    td {
      border-right: 1px solid #ebf0f5;
      text-align: center;
    }
    .act {
      color: #e61f26;
    }

    td:last-child {
      border: none;
    }
  }
  tr:last-child {
    border: none;
  }
}
.btnbox {
  margin-right: 0.24rem;
  overflow: hidden;
  margin-top: 0.05rem;
  .item {
    text-align: center;
    width: 0.9rem;
    height: 0.25rem;
    background: #f0e8e8;
	// background: yellow;
    border-radius: 0.06rem;
    float: right;
    margin-left: 0.12rem;
    font-size: 0.14rem;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #e61f26;
    line-height: 0.25rem;
  }
  .btnboxwithe {
    background: #ffffff;
  }
}
</style>
